export default "__VITE_ASSET__BU25jfeh__"